import { Injectable } from "@angular/core";
import { NestApiProvider } from "../../nest-api";
import { Observable } from "rxjs";
import { RequestCloseCaseDto, RequestSendReportDto } from "../dto/panic.dto";

@Injectable()
export class PanicApi {
  private service: string = '';
  private model: string = 'Panic';
  constructor(
    private nestApiProvider: NestApiProvider
  ) {

  }

  getAllCategories(): Observable<any> {
    const method: string = 'GET';
    const func: string = 'getAllCategories';
    const params = {};
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, params, urlParams, body);
  }
  
  getHistories(): Observable<any> {
    const method: string = 'GET';
    const func: string = 'getHistories';
    const params = {};
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, params, urlParams, body);
  }

  closeCase(payload: RequestCloseCaseDto): Observable<any> {
    const method: string = 'POST';
    const func: string = 'closeCase';
    const params = payload;
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, params, urlParams, body);
  }

  sendReport(payload: RequestSendReportDto): Observable<any> {
    const method: string = 'POST';
    const func: string = 'sendReport';
    const params = payload;
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, params, urlParams, body);
  }

  uploadUrl(){
    const method: string = 'POST';
    const func: string = 'uploadPhotos';
    const params = {};
    const urlParams: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return url;
  }

}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/panic.api.ts